const MessageTypes = require("../message-types");
/**
 * @typedef {Object} SocketAuth
 * @property {Number} organizationId
 * @property {String} internalId
 */

/**
 * @typedef {Object} UserProfile
 * @property {String} name
 * @property {String} bio
 * @property {String} avatarUrl
 */

/**
 *
 * @param socket
 * @param {SocketAuth} auth
 * @param {UserProfile} profile
 */
module.exports.subscribe = (socket, auth, profile) => {
  socket.emit(MessageTypes.SUBSCRIBE, {
    auth,
    profile
  });
};



// WEBPACK FOOTER //
// ../node_modules/@flic-chat/js-sdk/src/api/users.js